export default {
  methods: {
    convetMetersToHectareMix (me) {
      if (me !== null && me !== undefined) {
        return me / 10000
      } else {
        return 0
      }
    },

    convetHectareToMetersMix (he) {
      if (he !== null && he !== undefined) {
        return he * 10000
      } else {
        return 0
      }
    },

    isPersonMix (code) {
      return code !== null && code.indexOf('7003') !== -1
    },

    isOrganizationMix (code) {
      return code !== null && code.indexOf('7002') !== -1
    },

    createTreeListMix (list) {
      if (list === null) {
        return null
      }
      let arr = list.edges.map(item => {
        let a = {
          id: item.node.code,
          parent: item.node.parentCode !== null ? item.node.parentCode : '#',
          text: item.node.text
        }
        // console.log(a)
        return a
      })
      arr.sort((a, b) => {
        let textA = a.text.toLowerCase()
        let textB = b.text.toLowerCase()
        if (textA < textB) return -1
        if (textA > textB) return 1
        return 0
      })
      return arr
    },

    camelCaseKeysToUnderscore (obj) {
      if (typeof obj !== 'object') return obj

      for (var oldName in obj) {
        let newName = oldName.replace(/([A-Z])/g, function ($1) { return '_' + $1.toLowerCase() })

        // Only process if names are different
        if (newName !== oldName) {
          // Check for the old property name to avoid a ReferenceError in strict mode.
          if (obj.hasOwnProperty(oldName)) {
            obj[newName] = obj[oldName]
            delete obj[oldName]
          }
        }

        // Recursion
        if (typeof (obj[newName]) === 'object') {
          obj[newName] = this.camelCaseKeysToUnderscore(obj[newName])
        } else { // от меня. Если это "лист" объекта, то преобраховать в строку(бек ждет все в строках)
          obj[newName] = String(obj[newName])
        }
      }
      return obj
    },

    getBoundsFromGeometryMix (geometry) {
      let minX = 99999999
      let minY = 99999999
      let maxX = -99999999
      let maxY = -99999999

      if (geometry.type === 'Polygon') {
        let polygon = geometry.coordinates
        for (let i = 0; i < polygon.length; i++) {
          polygon[i].forEach(item => {
            if (item[0] <= minX) {
              minX = item[0]
            }
            if (item[0] >= maxX) {
              maxX = item[0]
            }
            if (item[1] <= minY) {
              minY = item[1]
            }
            if (item[1] >= maxY) {
              maxY = item[1]
            }
          })
        }
      } else if (geometry.type === 'MultiPolygon') {
        let multiPolygon = geometry.coordinates
        for (let i = 0; i < multiPolygon.length; i++) {
          for (let j = 0; j < multiPolygon[i].length; j++) {
            multiPolygon[i][j].forEach(item => {
              if (item[0] <= minX) {
                minX = item[0]
              }
              if (item[0] >= maxX) {
                maxX = item[0]
              }
              if (item[1] <= minY) {
                minY = item[1]
              }
              if (item[1] >= maxY) {
                maxY = item[1]
              }
            })
          }
        }
      }

      return [
        [minX, minY],
        [maxX, maxY]
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/utilsMix.js